import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "privacy",
  "use": "privacy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"privacy\"><path d=\"M11.556 6.667V4.889A3.555 3.555 0 008 1.333 3.555 3.555 0 004.445 4.89v1.778H3.11v3.11a4.897 4.897 0 004.89 4.89 4.897 4.897 0 004.888-4.89v-3.11h-1.333zM5.778 4.889a2.223 2.223 0 014.444 0v1.778H5.778V4.889zm5.778 4.889A3.555 3.555 0 018 13.333a3.555 3.555 0 01-3.555-3.555V8h7.11v1.778zm-4.222 1.555c0 .365.302.667.666.667a.671.671 0 00.667-.667v-.844A.975.975 0 008 8.8a.975.975 0 00-.666 1.689v.844z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol